import type { ReactNode } from 'react';
import { Icon } from '../icon/icon';
import { linkBase, visuallyHidden } from './link.css';

export interface LinkProps {
    children: ReactNode;
    href: string;
    /**
     * Opens the target in a new tab (with `rel="noreferrer noopener"`), appends a
     * trailing external-link glyph, and adds an "(opens in a new tab)" hint for
     * assistive tech. Use for deep-links out to other tools (e.g. the Azure blade).
     */
    external?: boolean;
    testID?: string;
}

/** Inline text link. Renders a real `<a>` so it is keyboard- and right-click-navigable. */
export function Link({ children, href, external = false, testID }: LinkProps) {
    return (
        <a
            className={linkBase}
            href={href}
            target={external ? '_blank' : undefined}
            rel={external ? 'noreferrer noopener' : undefined}
            data-testid={testID}
        >
            {children}
            {external ? (
                <>
                    <Icon name="external-link" size={14} />
                    <span className={visuallyHidden}> (opens in a new tab)</span>
                </>
            ) : null}
        </a>
    );
}
